module.exports = __webpack_public_path__ + "static/media/bungalow1.b34258bc.jpg";